Vue.component('ack-buy-buttons', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-buy-buttons',
	props: {
		isMobile: {
			type: Boolean,
			required: true,
		},
		shopProductInfo: {
			type: Object,
			required: true,
		},
		showQuantity: {
			type: Boolean,
			default: false,
		},
		showBuyNowAddToCartButtons: {
			type: Boolean,
			default: false,
		},
		bundleTag: {
			type: String,
			default: '',
		},
		disableWhereToBuy: {
			type: Boolean,
			required: false,
			default: false,
		},
		bundleTitle: {
			type: String,
			default: 'Purchase Now',
		},
	},
	computed: {
		...Vuex.mapGetters('shop', [
			'currentCurrency',
			'currentCurrencySymbol',
			'currentCountryCode',
			'isStoreAvailable',
		]),
		...Vuex.mapGetters('localization', ['redirectLinkWhenHideStore', 'isIreland', 'isTW']),
		isUSorCA() {
			return (
				this.currentCountryCode.toUpperCase() == 'US' ||
				this.currentCountryCode.toUpperCase() == 'CA'
			);
		},
		priceLabel() {
			return `${this.currentCurrencySymbol}${this.shopProductInfo.price} ${this.currentCurrency}`;
		},
		price() {
			return this.shopProductInfo.price;
		},
		variantId() {
			return `gid://shopify/ProductVariant/${this.shopProductInfo.variants[0].id}`;
		},
		productId() {
			return `gid://shopify/Product/${this.shopProductInfo.id}`;
		},
		mainImage() {
			return this.shopProductInfo.images[0];
		},
		showDistributorButtons() {
			return this.buyLocalButtons[this.currentCountryCode.toUpperCase()] != null;
		},
		currentCountryBuyLocalButtons() {
			let arr = [];

			if (this.buyLocalButtons[this.currentCountryCode.toUpperCase()] != null) {
				if (
					this.buyLocalButtons[this.currentCountryCode.toUpperCase()][this.shopProductInfo.id] !=
					null
				) {
					arr =
						this.buyLocalButtons[this.currentCountryCode.toUpperCase()][this.shopProductInfo.id];
				}
			}

			return arr;
		},
		currentProductClassName() {
			return this.productCssClass[this.shopProductInfo.id];
		},
		productIsNotAvailableInRegion() {
			let notAvailable = false;
			if (
				(this.shopProductInfo.id == '6571819466855' ||
					this.shopProductInfo.id == '6548762591335') &&
				(this.currentCountryCode.toUpperCase() == 'US' ||
					this.currentCountryCode.toUpperCase() == 'CA')
			) {
				notAvailable = true;
			}
			return notAvailable;
		},
		isPurchaseTemporarilyDisabled() {
			return isProductPurchaseTemporarilyDisabled(this.shopProductInfo.id);
		},
		storeCtaLabel() {
			if (this.shopProductInfo.handle === 'rodin-chroma-flash') {
				return 'Pre-order Chroma Flash';
			}

			return 'Purchase Now';
		},
		storeCtaHref() {
			if (this.shopProductInfo.handle === 'rodin-chroma-flash') {
				return '/pages/get-a-quote';
			}

			return `/pages/e-shop?bundle=${this.bundleTag}`;
		},
	},
	data() {
		return {
			showBundle: true,
			showDistributor: false,
			productCssClass: {
				7479252353127: 'sol',
				6548762591335: 'dentiq',
				6555508703335: 'cleani',
				6770993332327: 'curie-plus',
				6555508670567: 'curie',
				6571819466855: 'uv-box',
				6857640837223: 'sol-plus',
				6857633071207: 'cleani-tank-plus',
			},
			buyLocalButtons: {
				US: {
					// sol plus
					6857640837223: [
						{
							label: 'Argen',
							image: window.ackShopifyFileUrl('Argen.png'),
							cssClass: 'argen',
							url: 'https://www.argen.com/store/products/36443#/',
						},
						{
							label: 'Atlanta Dental',
							cssClass: 'atlanta-dental',
							url: 'https://atlantadental.com/dental-supplies/product/1134RS110010241',
						},
						{
							label: 'Burkhart Dental',
							cssClass: 'burkhart',
							url: 'https://www.burkhartdental.com/ackuretta-3d-printing-solution/ackuretta-sol-plus/',
						},
						{
							label: 'CAD-Ray',
							cssClass: 'cad-ray',
							url: 'https://www.cad-ray.com/product/sol-plus-by-ackuretta-3d-printer-with-concierge/',
						},
						{
							label: 'DHP',
							cssClass: 'dhp',
							url: 'https://www.dhpsupply.com/item/570-ACKRS110010241/SOL-Plus-3D-Printer/',
						},
						{
							label: 'Midwest Dental',
							cssClass: 'midwest-dental',
							url: 'https://midwestdental.com/sol-plus-3d-printer-wconcierge-service',
						},
						{
							label: 'Patterson Dental',
							cssClass: 'patterson-dental',
							url: 'https://www.pattersondental.com/equipment-technology/cad-cam/3d-printers/ackuretta-sol-plus',
						},
						{
							label: 'Starcona',
							cssClass: 'Starcona',
							url: 'https://Starcona.com/products/sol-plus-3d-printer-w-concierge-service?_pos=21&_sid=db4f630ba&_ss=r',
						},
						{
							label: 'Zahn',
							cssClass: 'zahn',
							url: 'https://www.henryschein.com/us-en/zahn/digitaldentistry/ackuretta-sol-plus.aspx',
						},
					],
					/* sol se */
					7479252353127: [
						{ label: 'Argen', cssClass: 'argen', url: 'https://argen.com/store/products/30372#/' },
						{
							label: 'Atlanta Dental',
							cssClass: 'atlanta-dental',
							url: 'https://atlantadental.com/dental-supplies/product/1134FP130020106',
						},
						{
							label: 'Burkhart Dental',
							cssClass: 'burkhart',
							url: 'https://www.burkhartdental.com/ackuretta-3d-printing-solution/ackuretta-sol/',
						},
						{
							label: 'CAD-Ray',
							cssClass: 'cad-ray',
							url: 'https://www.cad-ray.com/product/sol-by-ackuretta-3d-printer-lcd-dental-printer/',
						},
						{
							label: 'Darby Dental',
							cssClass: 'darby-dental',
							url: 'https://www.darbydental.com/categories/Equipment/3D-Printers-and-Resins/Ackuretta-3D-Printer/5256466',
						},
						{
							label: 'DHP',
							cssClass: 'dhp',
							url: 'https://www.dhpsupply.com/item/570-ACKRS110010240/SOL-3D-Printer-with-Concierge/',
						},
						{
							label: 'Henry Schein',
							cssClass: 'henry-schein',
							url: 'https://henryscheinequipmentcatalog.com/sol-3d-printer?utm_source=SupplierAckuretta&utm_medium=Website&utm_campaign=SupplierAckuretta%7CWebsite%7C2023%7CSOL%7C3DPT%7CDentalEquipment&utm_content=3DPT&utm_term=DentalEquipment',
						},
						{
							label: 'Midwest Dental',
							cssClass: 'midwest-dental',
							url: 'https://midwestdental.com/sol-3d-printer-wconcierge-service',
						},
						{
							label: 'Patterson Dental',
							cssClass: 'patterson-dental',
							url: 'https://www.pattersondental.com/equipment-technology/cad-cam/3d-printers/ackuretta-sol',
						},
						{
							label: 'Starcona',
							cssClass: 'Starcona',
							url: 'https://Starcona.com/products/sol-3d-printer-w-concierge-service?_pos=11&_sid=db4f630ba&_ss=r#description-tab-template--20066960310551__main',
						},
						{
							label: 'US Dental Depot',
							cssClass: 'usdental-depot',
							url: 'https://usdentaldepot.com/sol-lcd-3d-printer-roland-fp130020106-p476899',
						},
						{
							label: 'Zahn',
							cssClass: 'zahn',
							url: 'https://www.henryschein.com/us-en/zahn/DigitalDentistry/ackuretta-sol-3d-printer.aspx',
						},
					],
					/* dentiq */
					6548762591335: [],
					/* uv-box */
					6571819466855: [],
					// cleani tank plus
					6857633071207: [
						{
							label: 'Argen',
							cssClass: 'argen',
							url: 'https://www.argen.com/store/products/35530#/',
						},
						{
							label: 'Atlanta Dental',
							cssClass: 'atlanta-dental',
							url: 'https://atlantadental.com/dental-supplies/product/1134RS110010248',
						},
						{
							label: 'Burkhart Dental',
							cssClass: 'burkhart',
							url: 'https://www.burkhartdental.com/ackuretta-3d-printing-solution/ackuretta-cleani/',
						},
						{
							label: 'DHP',
							cssClass: 'dhp',
							url: 'https://www.dhpsupply.com/item/580-ACKRS110010248/Cleani-Tank-Plus-Kit/',
						},
						{
							label: 'Patterson Dental',
							cssClass: 'patterson-dental',
							url: 'https://www.pattersondental.com/Supplies/ItemDetail/071483692',
						},
						{
							label: 'Starcona',
							cssClass: 'Starcona',
							url: 'https://Starcona.com/products/cleani-1-tank-plus-kit-tank-plus-with-lid-mesh-basket-hydrometer?_pos=20&_sid=db4f630ba&_ss=r',
						},
					],
					/* cleani dual tanks */
					6555508703335: [
						{ label: 'Argen', cssClass: 'argen', url: 'https://argen.com/store/products/30373#/' },
						{
							label: 'Atlanta Dental',
							cssClass: 'atlanta-dental',
							url: 'https://atlantadental.com/dental-supplies/product/1134KT200180101',
						},
						{
							label: 'Burkhart Dental',
							cssClass: 'burkhart',
							url: 'https://www.burkhartdental.com/ackuretta-3d-printing-solution/ackuretta-cleani/',
						},
						{
							label: 'CAD-Ray',
							cssClass: 'cad-ray',
							url: 'https://www.cad-ray.com/product/ackuretta-cleani-professional-wash-dry-unit/',
						},
						{
							label: 'Darby Dental',
							cssClass: 'darby-dental',
							url: 'https://www.darbydental.com/categories/Equipment/3D-Printers-and-Resins/Ackuretta-3D-Printer/5256467',
						},
						{
							label: 'DHP',
							cssClass: 'dhp',
							url: 'https://www.dhpsupply.com/item/770-RS110010246/CLEANI-Post-Processing/',
						},
						{
							label: 'Henry Schein',
							cssClass: 'henry-schein',
							url: 'https://henryscheinequipmentcatalog.com/cleani-post-processing-unit?utm_source=SupplierAckuretta&utm_medium=Website&utm_campaign=SupplierAckuretta%7CWebsite%7C2023%7CCleani%7CPostUnit%7CDentalEquipment&utm_content=PostUnit&utm_term=DentalEquipment',
						},
						{
							label: 'Midwest Dental',
							cssClass: 'midwest-dental',
							url: 'https://midwestdental.com/cleani-dual-tank-3d-printer-washing-station',
						},
						{
							label: 'Patterson Dental',
							cssClass: 'patterson-dental',
							url: 'https://www.pattersondental.com/equipment-technology/cad-cam/3d-printers/ackuretta-cleani-washer',
						},
						{
							label: 'Starcona',
							cssClass: 'Starcona',
							url: 'https://Starcona.com/products/cleani-with-dual-tanks-post-processing-unit?_pos=26&_sid=906edfa47&_ss=r',
						},
						{
							label: 'US Dental Depot',
							cssClass: 'usdental-depot',
							url: 'https://usdentaldepot.com/sol-3d-printer-washing-station-roland-cleani',
						},
						{
							label: 'Zahn',
							cssClass: 'zahn',
							url: 'https://www.henryschein.com/us-en/zahn/digitaldentistry/ackuretta-cleani.aspx',
						},
					],
					/* curie-plus */
					6770993332327: [
						{ label: 'Argen', cssClass: 'argen', url: 'https://argen.com/store/products/34089#/' },
						{
							label: 'Atlanta Dental',
							cssClass: 'atlanta-dental',
							url: 'https://atlantadental.com/dental-supplies/product/1134RS110010162',
						},
						{
							label: 'Burkhart Dental',
							cssClass: 'burkhart',
							url: 'https://www.burkhartdental.com/ackuretta-3d-printing-solution/ackuretta-curie-plus/',
						},
						{
							label: 'CAD-Ray',
							cssClass: 'cad-ray',
							url: 'https://www.cad-ray.com/product/ackuretta-curie-plus-professional-curing-unit-uv-light-box',
						},
						{
							label: 'Darby Dental',
							cssClass: 'darby-dental',
							url: 'https://www.darbydental.com/categories/Equipment/3D-Printers-and-Resins/CURIE-Plus/5255977',
						},
						{
							label: 'DHP',
							cssClass: 'dhp',
							url: 'https://www.dhpsupply.com/item/770-RS110010162/CURIE-Plus-Post-Processing/',
						},
						{
							label: 'Midwest Dental',
							cssClass: 'midwest-dental',
							url: 'https://midwestdental.com/curie-plus-post-processing-unit',
						},
						{
							label: 'Patterson Dental',
							cssClass: 'patterson-dental',
							url: 'https://www.pattersondental.com/equipment-technology/cad-cam/3d-printers/ackuretta-curie-plus-curing-unit',
						},
						{
							label: 'Henry Schein',
							cssClass: 'henry-schein',
							url: 'https://www.henryscheindental.com/us-en/dental/p/laboratory/3d-printers-shared/curie-plus/1455840',
						},
						{
							label: 'US Dental Depot',
							cssClass: 'usdental-depot',
							url: 'https://usdentaldepot.com/curie-3d-printer-uv-oven-ackuretta-curie-p474958',
						},
						{
							label: 'zahn',
							cssClass: 'zahn',
							url: 'https://www.henryschein.com/us-en/zahn/digitaldentistry/ackuretta-curie-plus.aspx',
						},
					],
					/* curie */
					6555508670567: [
						{ label: 'Argen', cssClass: 'argen', url: 'https://argen.com/store/products/30374#/' },
						{
							label: 'Atlanta Dental',
							cssClass: 'atlanta-dental',
							url: 'https://atlantadental.com/dental-supplies/product/1134KT200200101',
						},
						{
							label: 'Burkhart Dental',
							cssClass: 'burkhart',
							url: 'https://www.burkhartdental.com/ackuretta-3d-printing-solution/ackuretta-curie/',
						},
						{
							label: 'CAD-Ray',
							cssClass: 'cad-ray',
							url: 'http://www.cad-ray.com/product-category/ackuretta',
						},
						{
							label: 'Darby Dental',
							cssClass: 'darby-dental',
							url: 'https://www.darbydental.com/categories/Equipment/3D-Printer/Ackuretta-3D-Printer/5255449',
						},
						{
							label: 'DHP',
							cssClass: 'dhp',
							url: 'https://www.dhpsupply.com/item/770-KT200200101/CURIE-Post-Processing/',
						},
						{
							label: 'Midwest Dental',
							cssClass: 'midwest-dental',
							url: 'https://midwestdental.com/curie-post-processing-unit',
						},
						{
							label: 'Patterson Dental',
							cssClass: 'patterson-dental',
							url: 'https://www.pattersondental.com/equipment-technology/cad-cam/3d-printers/ackuretta-curie-curing-unit',
						},
						{
							label: 'Starcona',
							cssClass: 'Starcona',
							url: 'https://Starcona.com/products/curie-post-processing-unit-high-capacity-3d-dental-curing-machine?_pos=2&_sid=35d20fb9f&_ss=r',
						},
						{
							label: 'US Dental Depot',
							cssClass: 'usdental-depot',
							url: 'https://usdentaldepot.com/curie-3d-printer-uv-oven-ackuretta-curie',
						},
						{
							label: 'Zahn',
							cssClass: 'zahn',
							url: 'https://www.henryschein.com/us-en/zahn/digitaldentistry/ackurette-curie.aspx',
						},
					],
				},
				CA: {
					/* sol se */
					7479252353127: [
						{
							label: 'Argen-CA',
							cssClass: 'argen-ca',
							url: 'https://argen.com/store/products/30372#/',
						},
						{
							label: 'Central Dental',
							cssClass: 'central-dental',
							url: 'https://www.centraldentalltd.com/products/details/22740/Ackuretta/FP130020106-SOL-130-3D-PRINTER-BY',
						},
						{
							label: 'Excel Dental',
							cssClass: 'excel-dental',
							url: 'https://exceldentalshop.com/sol-lcd-3d-printer.html',
						},
					],
					/* sol plus */
					6857640837223: [
						{
							label: 'Argen-CA',
							cssClass: 'argen-ca',
							url: 'https://argen.com/store/products/36443#/',
						},
						{
							label: 'Excel Dental',
							cssClass: 'excel-dental',
							url: 'https://exceldentalshop.com/sol-plus-3d-printer-powerhouse-for-digital-dentistry.html?search=sol%20plus',
						},
					],
					/* dentiq */
					6548762591335: [],
					/* cleani dual tanks*/
					6555508703335: [
						{
							label: 'Argen-CA',
							cssClass: 'argen-ca',
							url: 'https://argen.com/store/products/30373#/',
						},
						{
							label: 'Central Dental',
							cssClass: 'central-dental',
							url: 'https://www.centraldentalltd.com/products/details/22464/Ackuretta/KT200180101-CLEANI-FOR-3D-PRINTERS',
						},
						{
							label: 'Excel Dental',
							cssClass: 'excel-dental',
							url: 'https://exceldentalshop.com/cleani-washer-unit.html',
						},
					],
					/* uv-box */
					6571819466855: [],
					/* curie-plus */
					6770993332327: [
						{
							label: 'Argen-CA',
							cssClass: 'argen-ca',
							url: 'hhttps://argen.com/store/products/34089#/',
						},
						{
							label: 'Central Dental',
							cssClass: 'central-dental',
							url: 'https://www.centraldentalltd.com/products/details/24084/Ackuretta/RS110010162-CURIE-PLUS-UV-OVEN',
						},
						{
							label: 'Excel Dental',
							cssClass: 'excel-dental',
							url: 'https://exceldentalshop.com/curie-plus-the-ultimate-biocompatible-uv-curing-oven.html',
						},
					],
					/* curie */
					6555508670567: [
						{
							label: 'Argen-CA',
							cssClass: 'argen-ca',
							url: 'https://argen.com/store/products/30374#/',
						},
						{
							label: 'Central Dental',
							cssClass: 'central-dental',
							url: 'https://www.centraldentalltd.com/products/details/22915/Ackuretta/KT200200101-Curie-UV-Oven',
						},
						{
							label: 'Excel Dental',
							cssClass: 'excel-dental',
							url: 'https://exceldentalshop.com/curie.html',
						},
					],
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions('shop', ['addToCart', 'buyNow']),

		onBuyNowClick() {
			if (this.isPurchaseTemporarilyDisabled) return;

			this.buyNow({ variantId: this.variantId }).then((url) => {
				openCheckoutUrl(url);
			});
		},

		onAddToCartClick() {
			if (this.isPurchaseTemporarilyDisabled) return;

			var cartItem = new CartItem({
				productId: this.productId,
				variantId: this.variantId,
				pricePerUnit: parseFloat(this.price),
				img: this.mainImage,
				productTitle: this.shopProductInfo.title,
			});
			this.addToCart(cartItem);
		},
	},
	beforeDestroy() {},
	watch: {
		isMobile: {
			handler() {},
			deep: false,
		},
	},
});
